import { Injectable } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { NavStateContainer } from '../models/nav-state-container'
import { map, tap } from 'rxjs/operators'
import { from, Observable } from 'rxjs'
import TokenUtils from '../utils/token.utils'

/**
 *
 * @export
 */
@Injectable({
  providedIn: 'root'
})
export class JmlUrlParamService {
  public serializeRoute<T>(route: ActivatedRoute, state?: NavStateContainer<T>): Observable<NavStateContainer<T>> {
    return route.url.pipe(
      map((segments) => segments.join()),
      map((url) => {
        if (!state) {
          state = new NavStateContainer<T>()
        }
        state.url = url
        return state
      })
    )
  }

  public addUrlQueryParam<T>(router: Router, key: string, value: T): void {
    const param = {}
    param[key] = !!value ? value.toString() : value
    console.log('setting param:', param)
    router.navigate([], {
      queryParams: param,
      queryParamsHandling: 'merge',
      // skipLocationChange: false
      // skipLocationChange: true
      replaceUrl: true
    })
  }

  public removeUrlQueryParam = (router: Router, key: string): void => this.addUrlQueryParam(router, key, null)

  public readUrlQueryParam$(route: ActivatedRoute, key: string): Observable<string> {
    return route.queryParams.pipe(map((params) => params[key]))
  }

  public readToken = (route: ActivatedRoute): string => route.snapshot.paramMap.get(TokenUtils.TOKEN_KEY)
  public readToken$ = (route: ActivatedRoute): Observable<string> =>
    this.readUrlQueryParam$(route, TokenUtils.TOKEN_KEY)
  public writeToken = (router: Router, token: string): void =>
    this.addUrlQueryParam(router, TokenUtils.TOKEN_KEY, token)
  public hasToken$ = (route: ActivatedRoute): Observable<boolean> =>
    this.readToken$(route).pipe(map((token) => !!token))

  // entity id
  public readIdFromQueryParams$ = (route: ActivatedRoute): Observable<string> => this.readUrlQueryParam$(route, 'id')
  public clearId = (router: Router): void => {
    this.removeUrlQueryParam(router, 'id')
    console.log('removed id query param')
  }
  public setIdInQueryParams = (router: Router, id: string): void => {
    if (!id) {
      console.log('will not set undefined id: ', id)
      return
    }
    this.addUrlQueryParam(router, 'id', id)
  }
  public hasIdInQueryParams$ = (route: ActivatedRoute): Observable<boolean> =>
    this.readIdFromQueryParams$(route).pipe(map((id) => !!id))

  public readIdFromRouteParam$ = (route: ActivatedRoute): Observable<number> =>
    route.paramMap.pipe(map((paramMap) => +paramMap.get('id')))

  public setTypeAndId$ = (router: Router, values: { type?: string; id?: number }): Observable<any> => {
    return from(
      router.navigate([], {
        queryParams: {
          type: values.type,
          id: values.id
        },
        queryParamsHandling: 'merge',
        replaceUrl: true
      })
    )
  }
}
